"use client";

import React from "react";
import { HeartHandshake, Stethoscope, UserPlus, Syringe, Building2, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Orthopedic Surgery",
  description: "Specialized staffing for musculoskeletal procedures, joint replacements, and advanced trauma care.",
  icon: Stethoscope,
  link: "/facilities/"
}, {
  title: "Plastic Surgery",
  description: "Expert clinicians for reconstructive excellence and high-precision aesthetic surgical procedures.",
  icon: Syringe,
  link: "/facilities/"
}, {
  title: "Cardiovascular Surgery",
  description: "High-precision support for complex cardiac operations and major vascular surgical interventions.",
  icon: HeartHandshake,
  link: "/facilities/"
}, {
  title: "Neurosurgery",
  description: "Specialized teams for critical neurological, brain, and spinal procedures requiring elite precision.",
  icon: UserPlus,
  link: "/facilities/"
}, {
  title: "General Surgery",
  description: "Versatile surgical support for a wide range of abdominal, digestive, and systemic procedures.",
  icon: Building2,
  link: "/facilities/"
}];
export default function ServiceCards() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="171754" id="specialtiessupported" className="section bg-background">
      <div className="container max-w-7xl mx-auto">
        <div ref={headerRef} className={`max-w-3xl mx-auto text-center mb-12 md:mb-16 transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-sans text-3xl md:text-4xl font-semibold text-foreground mb-4 tracking-tight">
            Specialties Supported
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl font-sans">
            Delivering clinical precision through elite surgical staffing across our core medical disciplines.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {services.map((service, i) => {
          const {
            ref: cardRef,
            isVisible: isCardVisible
          } = useRevealOnScroll({
            threshold: 0.1
          });
          return <div key={i} data-index={i} ref={cardRef} className={`transition-all duration-700 ease-out ${isCardVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
            transitionDelay: `${i * 100}ms`
          }}>
                <Card className="text-card-foreground gap-6 py-6 h-full flex flex-col bg-card border-border/20 rounded-[12px] transition-shadow duration-300 !shadow-[0px_4px_8px_rgba(20,21,31,0.18),_0px_2px_4px_rgba(20,21,31,0.13)] hover:shadow-lg">
                  <CardHeader className="pb-4">
                    <div className="w-12 h-12 rounded-lg bg-background flex items-center justify-center mb-4 shadow-sm border border-border/10">
                      <service.icon className="w-6 h-6 text-secondary stroke-[2px]" />
                    </div>
                    <CardTitle className="font-sans text-xl font-semibold text-foreground">
                      {service.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="flex-grow">
                    <CardDescription className="font-sans text-base text-muted-foreground leading-relaxed">
                      {service.description}
                    </CardDescription>
                  </CardContent>
                  <CardFooter className="pt-2 pb-6">
                    <Button asChild variant="secondary" className="w-full group font-sans font-medium bg-linear-to-r from-[#1E4FA3] to-[#0A2E6E] text-white hover:opacity-90">
                      <Link to={service.link}>
                        View Details
                        <ArrowRight className="w-4 h-4 ml-2 transition-transform group-hover:translate-x-1" />
                      </Link>
                    </Button>
                  </CardFooter>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}